<template>
  <div class="inputContainer" :style="{width: width}">
    <input :id="id" :value="this.value" :placeholder="placeholder" @input="$emit('input', $event.target.value)"
           :disabled="disabled" required :class="{iconPadding: icon}" @keyup.enter="$emit('enter')">
    <span class="label">{{ label }}</span>
    <div v-if="icon" class="iconContainer" :class="{leftBorder: iconBorder, pointer: this.$listeners.click}">
            <span class="icon" :class="[icon]"
                  @click="$emit('click')" :style="{color: iconColor, fontSize: iconSize}"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "InputDetail",
  data: function () {
    return {};
  },
  props: {
    placeholder: String,
    disabled: Boolean,
    label: String,
    icon: String,
    iconColor: String,
    iconBorder: Boolean,
    iconSize: String,
    value: {
      required: true
    },
    width: String,
    id: String
  },
  methods: {
    updateValue: function (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped>
@use "@/assets/styles/variables.scss" as *;

.inputContainer {
  display: inline-block;
  position: relative;
  width: 100%;
}

input {
  padding: 1.1em 0.5em 0.5em 0.5em;
  width: 100%;
  font-size: 1em;
}

input::placeholder {
  color: #ccc;
}

input:disabled {
  background: transparent;
  border-color: transparent;
  border-bottom: 1px solid #ccc;
  color: black;
}

input.iconPadding {
  padding-right: 3em;
}

.label {
  position: absolute;
  left: 0.9em;
  top: 5px;
  font-size: 0.7em;
  color: #777;
  pointer-events: none;
  transition: 0.2s ease all;
}

.pointer {
  cursor: pointer;
}

.leftBorder {
  border-left: 1px solid #a9a9a9;
}

.iconContainer {
  position: absolute;
  top: 0;
  right: 0;
  //border-left: 1px solid #a9a9a9;
  width: 47px;
  height: 100%;
}

.icon {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  right: 0;
  font-size: 2.1em;
}

.icon:hover {
  color: $pink
}

.icon:before {
  display: flex;
}

</style>